import { c as _c } from "react/compiler-runtime";
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { defaultTranslationFunction, StreamI18n } from '../i18n/StreamI18n.js';
const StreamI18nContext = createContext({
  t: defaultTranslationFunction
});
const StreamI18nProvider = t0 => {
  const $ = _c(6);
  let children;
  let createI18nParams;
  if ($[0] !== t0) {
    ({
      children,
      ...createI18nParams
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = createI18nParams;
  } else {
    children = $[1];
    createI18nParams = $[2];
  }
  const api = useCreateI18n(createI18nParams);
  let t1;
  if ($[3] !== api || $[4] !== children) {
    t1 = jsx(StreamI18nContext.Provider, {
      value: api,
      children
    });
    $[3] = api;
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const useCreateI18n = t0 => {
  const $ = _c(14);
  const {
    i18nInstance,
    language,
    fallbackLanguage,
    translationsOverrides
  } = t0;
  let t1;
  if ($[0] !== fallbackLanguage || $[1] !== i18nInstance || $[2] !== language || $[3] !== translationsOverrides) {
    t1 = () => i18nInstance || new StreamI18n({
      currentLanguage: language,
      fallbackLanguage,
      translationsOverrides
    });
    $[0] = fallbackLanguage;
    $[1] = i18nInstance;
    $[2] = language;
    $[3] = translationsOverrides;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [i18n] = useState(t1);
  let t2;
  if ($[5] !== i18n.t) {
    t2 = () => i18n.t;
    $[5] = i18n.t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [t, setTranslationFn] = useState(t2);
  let t3;
  let t4;
  if ($[7] !== i18n || $[8] !== language) {
    t3 = () => {
      if (!i18n.isInitialized) {
        i18n.init().then(() => setTranslationFn(() => i18n.t));
      } else {
        if (i18n.currentLanguage !== language) {
          i18n.changeLanguage(language).then(() => setTranslationFn(() => i18n.t));
        }
      }
    };
    t4 = [i18n, language];
    $[7] = i18n;
    $[8] = language;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== i18n || $[12] !== t) {
    t5 = {
      i18n,
      t
    };
    $[11] = i18n;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
/**
 * A hook to get the i18n instance and translation function from the closest provider.
 *
 * Example usage:
 * const { t, i18n } = useI18n();
 * const message = t('hello_world');
 * console.log(message);
 */
const useI18n = () => {
  return useContext(StreamI18nContext);
};
export { StreamI18nProvider, useI18n };